// WARNING!!!!
// If this algo gets out of sync with slug generation on the mesvaccins website,
// links to vaccine documentation will be broken.
export function slugify(text: string): string {
  const slug = text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/"/g, "-quot-")
    .replace(/[^a-z0-9]+/gi, "-")
    .replace(/-{2,}/g, "-")
    .replace(/^-|-$/g, "")
    .toLowerCase();

  return slug;
}
